<template>
  <div class="ListagemDocs mx-2 mt-3">
    <div class="ListagemDocs_header col-12 m-0 p-0 d-inline-flex align-items-center">
      <div class="d-flex align-items-center justify-content-center col-2 m-0 p-0 mb-2 mr-4">
        Selecionar
      </div>
      <div class="col-2 m-0 p-0 mb-2">
        Registro
      </div>
      <div class="col-2 m-0 p-0 mb-2">
        Livro
      </div>
      <div class="col-3 m-0 p-0 mb-2">
        Tipo
      </div>
      <div class="col-3 m-0 p-0 mb-2">
        Imagem
      </div>
    </div>
    <div v-for="(item, index) in list"
         :key="index"
         class="ListagemDocs_body col-12 m-0 p-0 d-inline-flex align-items-center">
      <div class="d-flex align-items-center justify-content-center col-2 m-0 p-0 my-2 mr-4">
        <b-form-checkbox
          :id="`select_${ index }-${ _uid }`"
          v-model="selecteds"
          :name="`select_${ index }-${ _uid }`"
          :value="item.arquivo_id"
          @change="changeSelecteds(item.arquivo_id)" />
      </div>
      <div class="col-2 m-0 p-0 my-2">
        {{ item.registro_id }}
      </div>
      <div class="col-2 m-0 p-0 my-2">
        {{ item.num_livro }}
      </div>
      <div class="col-3 m-0 p-0 my-2 text-capitalize">
        {{ types[item.tipo_livro] }}
      </div>
      <div class="col-3 m-0 p-0 my-2 d-flex align-items-end ListagemDocs_imagem"
           @click="onPreviewClick(item)">
        <IconSvg icon="fileEye"
                 class="icon--sm m-0 p-0 mr-1 ListagemDocs_icon" />
        <p class="m-0 p-0">
          Visualizar
        </p>
      </div>
    </div>

    <b-modal v-if="showModal"
             id="visualizarDoc"
             ref="visualizarDoc"
             size="xl"
             visible
             hide-header
             @hidden="showModal = false">
      <object v-if="documentoUrl"
              class="embed-preview embed-responsive"
              :data="documentoUrl"
              type="application/pdf">
        <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando <a :href="documentoUrl">aqui</a>.</p>
      </object>
      <div slot="modal-footer"
           slot-scope="{ ok, cancel }">
        <button class="btn btn-secondary mr-2"
                @click="cancel()">
          Voltar
        </button>
      </div>
    </b-modal>
  </div>
</template>
<script>
  /* services */
  import DocumentosService from "@/services/Documentos"

  export default {
    name: "ListagemDocsPendentes",
    props: {
      propSelectAll: {type: Boolean, default: false},
      propLista: {type: Array, default: () => ([])},
      propSelecteds: {type: Array, default: () => ([])}
    },
    data () {
      return {
        list: [],
        types: {
          "O": "óbito",
          "N": "nascimento",
          "C": "casamento",
          "E": "livro e",
        },
        selecteds: [],
        documentoUrl: null,
        exceptions: [],
        showModal: false
      }
    },
    watch: {
      propLista () {
        this.list = [...this.propLista]

        //Selecionamos todas as opções caso a opção selecionar todos esteja ativa
        if (this.propSelectAll) {
          this.selecteds = this.propLista.map(item => item.arquivo_id)

          this.exceptions.forEach(exception => {
            const index = this.selecteds.findIndex(selected => selected == exception)

            if (index != -1) this.selecteds.splice(index, 1)
          })
        }
      },
      propSelecteds () {
        this.selecteds = []
        this.exceptions = []
        this.$emit("change", this.selecteds, this.exceptions)
      },
      propSelectAll () {
        if (this.propSelectAll) {
          this.selecteds = this.propLista.map(item => item.arquivo_id)
          this.exceptions = []
        }
        else this.selecteds = []

        this.$emit("change", this.selecteds, this.exceptions)
      }
    },
    mounted () {
      this.list = [...this.propLista]

      //Selecionamos todas as opções caso a opção selecionar todos esteja ativa
      if (this.propSelectAll) {
        this.selecteds = this.propLista.map(item => item.arquivo_id)

        this.exceptions.forEach(exception => {
          const index = this.selecteds.findIndex(selected => selected == exception)
          if (index != -1) this.selecteds.splice(index, 1)
        })
      }
    },
    methods: {
      async onPreviewClick (item) {
        loader({ text: 'Carregando documento...', active: true })
        try {

          const arquivo = await DocumentosService.getDocumento(`${item.arquivo_id}`)

          let blob = new Blob([arquivo], { type: 'application/pdf' })
          let url = window.URL.createObjectURL(blob)

          this.documentoUrl = url

          this.showModal = true
        } catch (e) {
          objSwal.error.title = 'Erro'
          objSwal.error.text = 'Erro ao procurar o arquivo, favor entrar em contato com o suporte'

          loader({ text: '', active: false })
          Swal.fire(objSwal.error).then(res => res)
        }

        loader({ text: '', active: false })
      },
      changeSelecteds (arquivo_id) {
        setTimeout(() => {
          const documento = this.selecteds.find(selected => selected == arquivo_id)

          if (documento) {
            const index = this.exceptions.findIndex(exception => exception == arquivo_id)

            //Removemos o documento da lista de exceptions caso ele esteja selecionado
            if (index != -1) {
              this.exceptions.splice(index, 1)
            }
          } else {
            //Lista de excessões para não assinar ou excluir os não selecionados com a opção selecionar todos ativa
            this.exceptions.push(arquivo_id)
          }

          this.$emit("change", this.selecteds, this.exceptions)
        }, 100)
      }
    }
  }
</script>
<style lang="scss">
  .ListagemDocs {
    &_header {
      font-size: 16px;
      font-weight: bold;
      color: #074f7f;
      border-bottom: solid 1px #074f7f;
    }

    &_body {
      font-size: 16px;
      font-weight: normal;
      color: #262626;
      border-bottom: solid 1px #074f7f;
    }

    &_imagem {
      cursor: pointer;
      text-decoration: underline;
      color: #074f7f;
      line-height: 1;
    }

    &_icon {
      width: 19px;
      height: 21px;
      fill: #074f7f;
    }
  }
</style>
